import {BehaviorSubject, Observable} from "rxjs";
import { chatConstants } from '@core/constants/chat.constants';
import {IOfficeChatSetting} from "./office-chat-setting-v1.types";
import Office from "@core/shared/office.instance";

export const OFFICE_KNOWLEDGE = {
    local: 'local',
    global: 'global',
    both: 'both'
}

export const OFFICE_SLOT = {
    main: 'main',
    stage: 'stage',
}

export const MANIFEST_VERSION = '1.2.1'

export const SETTING_TONE = chatConstants.SETTING_TONE;

export class OfficeChatSettingV1 {
    public $setting: BehaviorSubject<IOfficeChatSetting> = new BehaviorSubject<IOfficeChatSetting>({
        office_host: this.officeRuntime.HostType.Outlook,
        office_platform: this.officeRuntime.PlatformType.OfficeOnline,
        manifest_version: MANIFEST_VERSION,
        knowledge: OFFICE_KNOWLEDGE.global,
        slot: OFFICE_SLOT.main,
        role_information: SETTING_TONE.FORMAL,
        model: ''
    });
    constructor(protected readonly officeRuntime = Office) {
        this.initData();
    }

    private async initData(): Promise<void> {
        const officeInfo = await this.officeRuntime.onReady();
        const setting = this.$setting.getValue()
        const updateSetting = {
            ...setting,
            office_host: officeInfo.host,
            office_platform: officeInfo.platform
        }
        this.$setting.next(updateSetting);
    }

    protected get(): IOfficeChatSetting {
        return this.$setting.getValue()
    }

    protected $get(): Observable<IOfficeChatSetting> {
        return this.$setting.asObservable();
    }

    protected set(newSetting: IOfficeChatSetting): IOfficeChatSetting {
        const oldSetting = this.get();
        const nextSetting = {
            ...oldSetting,
            ...newSetting
        }
        this.$setting.next(nextSetting);
        return newSetting
    }
}
